import styled from "styled-components";
import React from "react";

export const FormFieldLabel = styled(props => <div {...props} />)
  .attrs((props) => ({
    automationid: `SalesLead_div_${props?.automationidattr?.replace(/ /g, "")}_1"`
  }))`
    font-family: 'Roboto' !important;
    font-weight: 500 !important;
    color: #282828;
    font-size: 16px;
    margin-bottom: 10px;
    visibility: ${props => props.hide ? 'hidden' : 'visible'};
    width: ${props => props.labelWidth ? props.labelWidth : '100%'};
    text-align: left;
  `;


